import { combineReducers } from "redux";

import { channels } from "./channels";
import { notifications } from "./notifications";
import { preferences } from "./preferences";

export default combineReducers({ channels, notifications, preferences });
